import Path from '@/utilities/bid/enums/Path'
import { NavigationGuardNext } from 'vue-router/types/router'
import { Store, Commit } from 'vuex'

const auth = ({ next, store }: { next: NavigationGuardNext; store: Store<Commit> }) => {
  if (!store.getters['Auth/isLoggedIn']) {
    return next(Path.LOGIN)
  }

  return next()
}

export default auth
